import { render, staticRenderFns } from "./StaticApi.vue?vue&type=template&id=46a745dc&scoped=true"
import script from "./StaticApi.vue?vue&type=script&lang=js"
export * from "./StaticApi.vue?vue&type=script&lang=js"
import style0 from "./StaticApi.vue?vue&type=style&index=0&id=46a745dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a745dc",
  null
  
)

export default component.exports